import React from 'react';
import styled from 'styled-components';
import { Image, Row, Line, Container, Col } from '../components';
import { useTranslation } from 'react-i18next';

const BoxWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 0;
  width: 100vw;

  @media (max-width: 768px) {
    max-width: 100%;
    flex-direction: column;
    align-items: center;
  }
`

const Box = styled.div`
  position: relative;
  height: 550px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${require('assets/products/transition.jpeg')});
    background-size: cover;
    background-position: center;
    opacity: 0.7;
    z-index: -1;
  }

  @media (max-width: 768px) {
    height: 300px;
  }
`

const TitleWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 12px;
  flex-direction: column;
  
  

  @media (max-width: 768px) {
    max-width: 768px
    align-items: center;
  }
`

const Title = styled.h1`
  color: #b19961;
  font-size: 100px;
  margin: 0;
  font-weight: 400;
  opacity: 1;

  @media (max-width: 768px) {
    font-size: 40px;
  }
`

const Text = styled.p`
  font-weight: 300;
  font-size: 20px;  
  color: '#363535';

  @media (max-width: 768px) {
    font-size: 16px;
  }
`

const SingleImage = styled.div`
  width: 500px;
  height: 500px;
  background: url(${props => props.img});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: -1;
  margin: 0;

  @media (max-width: 768px) {
    display: none;
    margin: 0;
    padding: 0;
  }
`

const Products = () => {
  const { t } = useTranslation()

  return (
    <Container id='products'>
      <Line/>
      <BoxWrapper>
        <Box>
          <Title>{t('products.title')}</Title>
        </Box>
      </BoxWrapper>
      <Line/>
       
      <Col pad=' 0 20px'>
        {/* RACE */}
        
        <Row between>
          <TitleWrapper align='left'>
            <Title>{t('products.race')}</Title>
            <Text>{t('products.race1')}</Text>
            <Text>{t('products.race2')}</Text>
            
            <Text>{t('products.race3_title')}</Text>
            
            <ul>
              {t('products.race3_points', { returnObjects: true }).map((point, index) => (
                <li key={index}>
                  <Text>{point}</Text>
                </li>
              ))}
            </ul>
          </TitleWrapper>
          <SingleImage img={require('assets/products/race1.png')} />
        </Row>
        <Image height='250px' wid='250px'
          img1={require('assets/products/race2.png' )}
          img2={require('assets/products/race3.png')}
        />
        <Row>
          <TitleWrapper>
            <Text>{t('products.race4')}</Text>
            <Text>{t('products.race5')}</Text>
            <Text>{t('products.race6')}</Text>
            <Text>{t('products.race7')}</Text>
            <Text>{t('products.race8')}</Text>
          </TitleWrapper>
        </Row>
      {/* STAR */}
      <Line/>

        <Row between>
          <TitleWrapper>
            <Title>{t('products.star')}</Title>
            <Text>{t('products.star1')}</Text>
            
            <Text>{t('products.star2_title')}</Text>
            
            <ul>
              {t('products.star2_points', { returnObjects: true }).map((point, index) => (
                <li key={index}>
                  <Text>{point}</Text>
                </li>
              ))}
            </ul>
          </TitleWrapper>
          
          <SingleImage img={require('assets/products/star1.png')} />
        </Row>
        <Image height='250px' wid='250px'
          img1={require('assets/products/star2.png')} 
          img2={require('assets/products/star3.png')}
        />
       <Row>
          <TitleWrapper align='left'>
            <Text>{t('products.star3')}</Text>
            <Text>{t('products.star4')}</Text>
            <Text>{t('products.star5')}</Text>
            <Text>{t('products.star6')}</Text>
            <Text>{t('products.star7')}</Text>
          </TitleWrapper>
        </Row>
     
        {/* FLEX */}
      <Line/>        
      <Row between>
        <TitleWrapper align='left'>
          <Title>{t('products.flex')}</Title>
          <Text>{t('products.flex1')}</Text>
          
          <Text>{t('products.flex2_title')}</Text>
          
          <ul>
            {t('products.flex2_points', { returnObjects: true }).map((point, index) => (
              <li key={index}>
                <Text>{point}</Text>
              </li>
            ))}
          </ul>
        </TitleWrapper>
        <SingleImage img={require('assets/products/flex1.png')} />
      </Row>
      <Image height='250px' wid='250px'
        img1={require('assets/products/flex2.jpeg')}
        img2={require('assets/products/flex3.png')}
      />
      <Row>
        <TitleWrapper align='left'>
          <Text>{t('products.flex3')}</Text>
          <Text>{t('products.flex4')}</Text>
          <Text>{t('products.flex5')}</Text>
          <Text>{t('products.flex6')}</Text>
          <Text>{t('products.flex7')}</Text>
          <Text>{t('products.flex8')}</Text>
        </TitleWrapper>
      </Row>  
      <Line/>
    </Col>
    </Container>
  )
}

export default Products
